import MyNavbar from "./Components/MyNavbar";
import "./App.css"
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./Components/Home";
// import Projects from "./Components/Projects";
import Services from "./Components/Services";
import Career from "./Components/Career";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer"
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <MyNavbar />
        <Home />
      </>
    ),
  },
  // {
  //   path: "/projects",
  //   element: (
  //     <>
  //       <MyNavbar />
  //       <Projects />
  //     </>
  //   ),
  // },
  {
    path: "/services",
    element: (
      <>
        <MyNavbar />
        <Services />
      </>
    ),
  },
  {
    path: "/career",
    element: (
      <>
        <MyNavbar />
        <Career />
      </>
    ),
  },
  {
    path: "/contact",
    element: (
      <>
        <MyNavbar />
        <Contact />
      </>
    ),
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Footer />
    </>
  );
}

export default App;
